import { TagGroupField } from 'lib/iterable-hook-form/FormField';
import { useCampaignProjectLabels } from 'modules/campaigns/lib/hooks/useCampaignProjectLabels/useCampaignProjectLabels';
import { CampaignLabel } from 'modules/domains/campaign';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { TAG_SIZES } from 'ui/tags';
import { spacing } from 'ui/theme';

const StyledTagGroupField = styled(TagGroupField)`
  margin-bottom: ${spacing.double};
`;

export const EditableLabels = ({
  name = 'labels',
  isEditable = true,
  className,
}: {
  name?: string;
  isEditable?: boolean;
  className?: string;
}) => {
  const labels = useWatch({
    name,
  });

  const { isLoading, results: campaignProjectLabels } = useCampaignProjectLabels();

  const availableLabelTags = useMemo(
    () =>
      campaignProjectLabels
        .filter((label: CampaignLabel) => !labels?.some((val: string) => val === label.name))
        .map((label: CampaignLabel) => label.name),
    [campaignProjectLabels, labels],
  );

  return (
    <>
      {!isLoading && (
        <StyledTagGroupField
          name={name}
          tagSize={TAG_SIZES.LARGE}
          isEditable={isEditable}
          isAutoSaveEnabled
          tags={availableLabelTags}
          className={className}
        />
      )}
    </>
  );
};
